import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";

export class AuwProductSwitcher extends AuwBaseComponent {
    constructor($el) {
        super($el);
    }

    __PageReady() {
        const btnInitial = $('#productSwitcher__initial');
        const btnStudent = $('#productSwitcher__student');
        const btnYoung = $('#productSwitcher__young');

        const productListInitial = $('#productList--initial');
        const productListStudent = $('#productList--student');
        const productListYoung = $('#productList--young');

        const studentBenefit = $('#studentBenefit');
        const youngBenefit = $('#youngBenefit');

        btnInitial.on('click', function () {
            $(this).addClass('btn-active');
            btnStudent.removeClass('btn-active');
            btnYoung.removeClass('btn-active');

            productListInitial.show();
            productListStudent.hide();
            productListYoung.hide();

            studentBenefit.hide();
            youngBenefit.hide();
        });

        btnStudent.on('click', function () {
            $(this).addClass('btn-active');

            btnInitial.removeClass('btn-active');
            btnYoung.removeClass('btn-active');

            productListStudent.show();
            productListInitial.hide();
            productListYoung.hide();

            studentBenefit.css('display', 'flex');
            youngBenefit.hide();
        });

        btnYoung.on('click', function () {
            $(this).addClass('btn-active');

            btnInitial.removeClass('btn-active');
            btnStudent.removeClass('btn-active');

            productListYoung.show();
            productListInitial.hide();
            productListStudent.hide();

            youngBenefit.css('display', 'flex');
            studentBenefit.hide();
        });
    }
}

const productWrapper = $('.productWrapper');
if (productWrapper.length) {
    $.each(productWrapper, function (i, e) {
        new AuwProductSwitcher($(e));
    });
}
